import { type ObjectValuesUnionType } from '../../utils/typing';

export const ReviewActionTypes = Object.freeze({
  CHECK: 'review/check',
  CLOSE_DIALOG: 'review/closeDialog',
  DISABLE: 'review/disable',
  OPEN_DIALOG: 'review/openDialog',
  RATE: 'review/rate',
});

export type ReviewActionType = ObjectValuesUnionType<typeof ReviewActionTypes>;
